import { render, staticRenderFns } from "./NewsBannersCard.vue?vue&type=template&id=c3a8eb6a&"
import script from "./NewsBannersCard.vue?vue&type=script&lang=js&"
export * from "./NewsBannersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a8eb6a')) {
      api.createRecord('c3a8eb6a', component.options)
    } else {
      api.reload('c3a8eb6a', component.options)
    }
    module.hot.accept("./NewsBannersCard.vue?vue&type=template&id=c3a8eb6a&", function () {
      api.rerender('c3a8eb6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/NewsBannersCard.vue"
export default component.exports